/* eslint-disable arrow-body-style */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { env } from '@amfam/environment';
import { userQuery } from '@amfam/shared/user';

import { Credentials, userDetails } from '../models/delete.model';

@Injectable()
export class DeleteService {
  private digitalAccountApiUrl: string;
  private authenticateUrl: string;
  private deleteAccountApiUrl: string;
  private unenrollUrl: string;
  private deleteUrl: string;
  private unenrollUrlAdmin: string;
  private deleteUrlAdmin: string;
  private communicationApiUrl: string;
  private templatedEmailUrl: string;
  private appName: string;

  constructor(
    private store: Store,
    private http: HttpClient
  ) {
    this.appName = env.applicationTitle;
    this.deleteAccountApiUrl = env.deleteAccountApi;
    this.digitalAccountApiUrl = env.digitalAccountApi;
    this.communicationApiUrl = env.communicationApi;

    this.authenticateUrl = this.digitalAccountApiUrl + '/digitalaccounts/authenticate';
    this.unenrollUrl = this.deleteAccountApiUrl + '/unenrollprograms/WAID-CTDNC';
    this.unenrollUrlAdmin = this.deleteAccountApiUrl + '/unenrollprograms/';
    this.deleteUrlAdmin = this.deleteAccountApiUrl + '/delete/';
    this.deleteUrl = this.deleteAccountApiUrl + '/delete/WAID-CTDNC';
    this.templatedEmailUrl = this.communicationApiUrl + 'templatedemails';
  }

  authenticate(payload: Credentials): Observable<any> {
    const body = {};
    let headers = new HttpHeaders();
    headers = headers.set(
      'Authorization',
      'Basic ' + btoa(payload.username + ':' + payload.password)
    );

    return this.http.post(this.authenticateUrl, body, { headers: headers }).pipe(
      map((data: any) => {
        return data;
      })
    );
  }

  unenrollPrograms(): Observable<any> {
    if (this.appName === 'MyAccountAdmin') {
      const waid = this.retreiveWaid();
      const unenrollUrlInternal = this.unenrollUrlAdmin + waid;
      return this.http.post(unenrollUrlInternal, {}).pipe(
        map((data: any) => {
          return data;
        })
      );
    } else {
      const CustkeyToken = this.retreiveToken();
      const httpOptions = {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + CustkeyToken
        })
      };

      const body = {};

      return this.http.post(this.unenrollUrl, body, { headers: httpOptions.headers }).pipe(
        map((data: any) => {
          return data;
        })
      );
    }
  }

  deleteMyaccount(): Observable<any> {
    if (this.appName === 'MyAccountAdmin') {
      const waid = this.retreiveWaid();

      const body = {
        reason: 'Delete MyAccount - Agent initiated via Web app'
      };

      const deleteUrlInternal = this.deleteUrlAdmin + waid;

      return this.http.post(deleteUrlInternal, body).pipe(
        map((data: any) => {
          return data;
        })
      );
    } else {
      const CustkeyToken = this.retreiveToken();
      const httpOptions = {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + CustkeyToken
        })
      };

      const body = {
        reason: 'Delete MyAccount - User initiated via Web app'
      };

      return this.http.post(this.deleteUrl, body, { headers: httpOptions.headers }).pipe(
        map((data: any) => {
          return data;
        })
      );
    }
  }

  sendTemplatedEmails(payload: userDetails): Observable<any> {
    const CustkeyToken = this.retreiveToken();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: 'Bearer ' + CustkeyToken
      })
    };

    const body = {
      brandId: 'MyAccount',
      language: 'EN',
      messageDetails: [
        {
          key: 'EmailAddress',
          value: ''
        },
        {
          key: 'SubscriberKey',
          value: ''
        },
        {
          key: 'FirstName',
          value: payload.firstName
        }
      ],
      partnerId: 'AFI',
      recipientAddress: payload.email,
      templateCode: 'MYAC_DEL'
    };

    if (this.appName === 'MyAccountAdmin') {
      return this.http.post(this.templatedEmailUrl, body).pipe(
        map((data: any) => {
          return data;
        })
      );
    } else {
      return this.http.post(this.templatedEmailUrl, body, { headers: httpOptions.headers }).pipe(
        map((data: any) => {
          return data;
        })
      );
    }
  }

  retreiveToken(): string {
    let CustkeyToken = '';
    this.store
      .select(userQuery.selectCUSTKEY)
      .pipe(take(1))
      .subscribe(token => (CustkeyToken = token));
    return CustkeyToken;
  }

  retreiveWaid(): string {
    let waid = '';
    this.store
      .select(userQuery.selectWaid)
      .pipe(take(1))
      .subscribe(waId => (waid = waId));
    return waid;
  }
}
